import { Company } from "@finway-group/shared/lib/models"
import axios from "axios"

const MODEL = "company"

const CompanyService = {
    updateCompany: async (newCompany: Company): Promise<Company> => {
        const { data } = await axios.put(`/company/${newCompany._id}`, newCompany)
        return data as any
    },
    fetchCompany: async (): Promise<Company> => {
        const { data } = await axios.get(`/${MODEL}`)
        return data as Company
    },
    fetchCompanies: async () => {
        const { data } = await axios.get(`/${MODEL}`)
        return data as Company[]
    },
    createCompany: async (newCompany: Company) => {
        const { data } = await axios.post(`/${MODEL}`, newCompany)
        return data
    },
    deleteCompany: async (id: string) => {
        const { data } = await axios.delete(`/${MODEL}/${id}`)
        return data
    },
    connectDatevOnline: async () => {
        const { data } = await axios.get(`/${MODEL}/datev/connect`)
        return data
    },
    revokeDatevConsent: async () => {
        const { data } = await axios.put(`/${MODEL}/datev/revoke-consent`)
        return data
    },
    updateDatevAutoExport: async (autoExport: boolean) => {
        const { data } = await axios.put(`/${MODEL}/datev/auto-export`, { autoExport })
        return data
    },
    abortDatevSetup: async () => {
        const { data } = await axios.put(`/${MODEL}/datev/setup-abort`)
        return data
    },
    // TODO: fix any
    updateBankSubjectParts: async (id: string, customBankSubjectParts: any[]) => {
        const { data } = await axios.put(`/${MODEL}/${id}/bank-subject-line`, { customBankSubjectParts })
        return data
    },
    updateDatevInfo: async (id: string, customDatevFields: any) => {
        const { data } = await axios.patch(`/${MODEL}/${id}/custom-datev-fields`, { customDatevFields })
        return data
    },
}

export default CompanyService
